// Date formats
export const DOB_SLASH_FORMAT = /^\d{1,2}\/\d{1,2}\/\d{4}$/; // MM/DD/YYYY (1-2 digits for M and D)
export const DOB_CAPTURE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/; // capture groups

// Combinations of DOB and Last Name
export const DOB_THEN_LASTNAME = /^(\d{1,2}\/\d{1,2}\/\d{4})\s+([A-Za-z]+)$/;
export const LASTNAME_THEN_DOB = /^([A-Za-z]+)\s+(\d{1,2}\/\d{1,2}\/\d{4})$/;

// Last name formats
export const LASTNAME_MIN3 = /^[A-Za-z]{3,}$/;
export const LASTNAME_ONLY = /^[A-Za-z]+$/;
export const LASTNAME_WITH_NUMBERS_A = /[A-Za-z]+\d/;
export const LASTNAME_WITH_NUMBERS_B = /\d[A-Za-z]+/;

// Allowed characters for combined input
export const ALLOWED_DOB_LASTNAME_CHARS = /^[\d\/\sA-Za-z]+$/;

// Spacing
export const MULTIPLE_SPACES = /\s{2,}/;
export const ANY_WHITESPACE = /\s/;

// Medicaid ID
export const ALPHANUMERIC = /^[A-Za-z0-9]+$/;

